(function() { window.GUID_690ee6b1_8b1a_40ae_a32b_9ac5071eca2d = { getGuid: function() { return "690ee6b1-8b1a-40ae-a32b-9ac5071eca2d"; } }; })();
var CS;
(function (CS) {
    let $iframe = null;
    function ShowPrintDialog(url) {
        if ($iframe != null && $iframe.length > 0) {
            let iframe = $iframe[0];
            iframe.src = url;
        }
        else {
            $iframe = $('<iframe id="AutoPrintDialogPdf" style="display:none;"></iframe>');
            let iframe = $iframe[0];
            iframe.src = url;
            iframe.onload = function () {
                setTimeout(function () {
                    iframe.focus();
                    iframe.contentWindow.print();
                }, 1);
            };
            CS.body.append($iframe);
        }
    }
    CS.ShowPrintDialog = ShowPrintDialog;
})(CS || (CS = {}));

//# sourceMappingURL=autoprintdialog.js.map
